import { render, staticRenderFns } from "./UploadPhoto.vue?vue&type=template&id=607b89a5"
import script from "./UploadPhoto.vue?vue&type=script&lang=js"
export * from "./UploadPhoto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports